import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>404 😕</h1>
      <h2>Página não encontrada</h2>
      <p>Verifique o endereço ou volte para o início.</p>

      <div style={{ marginTop: 20 }}>
        <Link to="/login">Ir para Login</Link>
      </div>
    </div>
  )
}
